import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { getDefaultRoute } from "@/lib/permissions";
import { Toaster } from "@/components/ui/sonner";
import LoginPage from "@/pages/LoginPage";
import TrazabilidadPublicaPage from "@/pages/TrazabilidadPublicaPage";
import DashboardPage from "@/pages/DashboardPage";
import PlanCuentasPage from "@/pages/PlanCuentasPage";
import SumasSaldosPage from "@/pages/SumasSaldosPage";
import ComprasAClasificarPage from "@/pages/ComprasAClasificarPage";
import MovimientosAClasificarPage from "@/pages/MovimientosAClasificarPage";
import PromocionesPage from "@/pages/PromocionesPage";
import FacturasPage from "@/pages/FacturasPage";
import ComprasPage from "@/pages/ComprasPage";
import OrdenCompraPage from "@/pages/OrdenCompraPage";
import ProductosPage from "@/pages/ProductosPage";
import InsumosPage from "@/pages/InsumosPage";
import CtaCtePage from "@/pages/CtaCtePage";
import CajasPage from "@/pages/CajasPage";
import AsientosPage from "@/pages/AsientosPage";
import AdminUsersPage from "@/pages/AdminUsersPage";
import MantenimientoPage from "@/pages/MantenimientoPage";
import MediosPagoPage from "@/pages/MediosPagoPage";
import PasivosEntidadesPage from "@/pages/PasivosEntidadesPage";
import PasivosSaldosPage from "@/pages/PasivosSaldosPage";
import GastosEstructuraPage from "@/pages/GastosEstructuraPage";
import AdminLabelsPage from "@/pages/AdminLabelsPage";
import AuditoriaPage from "@/pages/AuditoriaPage";
import AuditoriaSalidaPage from "@/pages/AuditoriaSalidaPage";
import EspecificacionesPage from "@/pages/EspecificacionesPage";
import CashFlow2Page from "@/pages/CashFlow2Page";
import ChequesPage from "@/pages/ChequesPage";
import ChequesEmitidosPage from "@/pages/ChequesEmitidosPage";
import MovimientosCajasPage from "@/pages/MovimientosCajasPage";
import RECPage from "@/pages/RECPage";
import TiendaNubePage from "@/pages/TiendaNubePage";
import PedidosPage from "@/pages/PedidosPage";
import OrdenesTrabajoPage from "@/pages/OrdenesTrabajoPage";
import RecepcionMercaderiaPage from "@/pages/RecepcionMercaderiaPage";
import LogisticaPage from "@/pages/LogisticaPage";
import TransportistasPage from "@/pages/TransportistasPage";
import VehiculosPage from "@/pages/VehiculosPage";
import StockPage from "@/pages/StockPage";
import TransformacionesPage from "@/pages/TransformacionesPage";
import RecetasPage from "@/pages/RecetasPage";
import ControlSalidaPage from "@/pages/ControlSalidaPage";
import InventarioPage from "@/pages/InventarioPage";
import POSPage from "@/pages/POSPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/layout/AppLayout";

function DefaultRedirect() {
  const { user } = useAuth();
  return <Navigate to={getDefaultRoute(user)} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CurrencyProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/trazabilidad/:lid" element={<TrazabilidadPublicaPage />} />
              <Route
                path="/pos"
                element={
                  <ProtectedRoute>
                    <POSPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <AppLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<DefaultRedirect />} />
                <Route path="dashboard" element={<DashboardPage />} />
                <Route path="plan-cuentas" element={<PlanCuentasPage />} />
                <Route path="sumas-saldos" element={<SumasSaldosPage />} />
                <Route path="compras-a-clasificar" element={<ComprasAClasificarPage />} />
                <Route path="movimientos-a-clasificar" element={<MovimientosAClasificarPage />} />
                <Route path="promociones" element={<PromocionesPage />} />
                <Route path="ventas" element={<FacturasPage tipo="venta" />} />
                <Route path="compras" element={<ComprasPage />} />
                <Route path="orden-compra" element={<OrdenCompraPage />} />
                <Route path="productos" element={<ProductosPage />} />
                <Route path="insumos" element={<InsumosPage />} />
                <Route path="clientes" element={<CtaCtePage tipo="cliente" />} />
                <Route path="proveedores" element={<CtaCtePage tipo="proveedor" />} />
                <Route path="cajas" element={<CajasPage />} />
                <Route path="asientos" element={<AsientosPage />} />
                <Route path="cashflow" element={<Navigate to="/cashflow-2" replace />} />
                <Route path="cashflow-2" element={<CashFlow2Page />} />
                <Route path="cheques" element={<ChequesPage />} />
                <Route path="cheques-emitidos" element={<ChequesEmitidosPage />} />
                <Route path="movimientos-cajas" element={<MovimientosCajasPage />} />
                <Route path="rec" element={<RECPage />} />
                <Route path="tienda-nube" element={<TiendaNubePage />} />
                <Route path="pedidos" element={<PedidosPage />} />
                <Route path="produccion/ordenes-trabajo" element={<OrdenesTrabajoPage />} />
                <Route path="produccion/recepcion" element={<RecepcionMercaderiaPage />} />
                <Route path="logistica" element={<LogisticaPage />} />
                <Route path="logistica/transportistas" element={<TransportistasPage />} />
                <Route path="logistica/vehiculos" element={<VehiculosPage />} />
                <Route path="stock" element={<StockPage />} />
                <Route path="produccion/transformaciones" element={<TransformacionesPage />} />
                <Route path="produccion/recetas" element={<RecetasPage />} />
                <Route path="produccion/control-salida" element={<ControlSalidaPage />} />
                <Route path="produccion/inventario" element={<InventarioPage />} />
                <Route path="admin-users" element={<AdminUsersPage />} />
                <Route path="mantenimiento" element={<MantenimientoPage />} />
                <Route path="medios-pago" element={<MediosPagoPage />} />
                <Route path="pasivos/entidades" element={<PasivosEntidadesPage />} />
                <Route path="pasivos/saldos" element={<PasivosSaldosPage />} />
                <Route path="gastos-estructura" element={<GastosEstructuraPage />} />
                <Route path="etiquetas" element={<AdminLabelsPage />} />
                <Route path="especificaciones" element={<EspecificacionesPage />} />
                <Route path="auditoria" element={<AuditoriaPage />} />
                <Route path="auditoria/salida" element={<AuditoriaSalidaPage />} />
              </Route>
              <Route path="*" element={<DefaultRedirect />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </CurrencyProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
